export default __webpack_public_path__ + "static/media/shelley kloba.62ff1596.jpg";